import React from "react";
import StepCreator from "../../step-creator/StepCreator";

export default function StepCreation() {
  return (
    <>
      <div className="mb-5">
        <StepCreator />
      </div>
    </>
  );
}
